module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/stream-browser.js
// module chunks = 4